import {Component, EventEmitter, Input, OnDestroy, Output} from '@angular/core';
import {takeUntil} from "rxjs/operators";
import {Receipts} from "../../interfaces/receipts";
import {BaseService} from "../../services/base.service";
import {Subject} from "rxjs";
import {HttpClient} from "@angular/common/http";

@Component({
  selector: 'app-modal-receipts',
  templateUrl: './modal-receipts.component.html',
  styleUrls: ['./modal-receipts.component.scss']
})
export class ModalReceiptsComponent extends BaseService implements OnDestroy {
  @Input() receiptsList = [];

  public isDestroyed: Subject<boolean> = new Subject<boolean>();
  public isModalReceiptsShow: boolean = false;
  public isDarkBackground: boolean = false;

  constructor(
    private http: HttpClient
  ) {
    super();
  }

  openModalReceiptsShow() {
    this.http.get(this.apiRoot + 'header/receipts')
      .pipe(takeUntil(this.isDestroyed))
      .subscribe((data: Receipts) => {
        this.receiptsList = data.data;
      });

    this.isModalReceiptsShow = true;
    this.isDarkBackground = true;
  }

  goToReceiptData(date) {
    document.location = `/account?receipt_date=${date}`;
    this.closeModal();
  }

  closeModal() {
    this.isModalReceiptsShow = false;
    this.isDarkBackground = false;
  }

  ngOnDestroy() {
    this.isDestroyed.next(true);
    this.isDestroyed.complete();
  }
}
